import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import {
  setDocumentCreateData,
  setMetaData,
  setNextDocumentCreateData,
  setProcessId,
  setRichText
} from "../../massiveDocumentCreate";
import { createDocumentFromTemplate } from "../../massiveDocumentCreate/actions/createDocumentFromTemplate";
import { findTemplateQuestions } from "../../massiveDocumentCreate/actions/findTemplateQuestions";
import { RootState } from "../../rootReducer";

export const createAllAutomatticDocuments = createAsyncThunk(
  "userTemplate/createAllAutomatticDocuments",
  async (data: { template: string, userId: string, assign: boolean }, { rejectWithValue, getState, dispatch }) => {

    const state = getState() as RootState;
    const automatticTemplates = state.userTemplate.automatticTemplates;
    const userRole = state.userShow.userRoles!;
    const user = state.userShow.user;
    const iDokSignatureProvider = state.signatureProviders.providers.filter((provider) => provider.name === "iDok");

    try {
      await dispatch(setDocumentCreateData({}));

      const prepareStore = async () => {
        await dispatch(setProcessId(0));
        await dispatch(setMetaData([]));
        await dispatch(setRichText(""));
      };

      await prepareStore();

      for (const templateItem of automatticTemplates) {
        try {
          const data = {
            title: templateItem.label,
            category: templateItem.category,
            template: templateItem.template,
            legalRep: templateItem.legalRepresentative !== null ? templateItem.legalRepresentative : {},
            signatureProvider: templateItem.signatureProvider !== null ? templateItem.signatureProvider : iDokSignatureProvider[0],
          }
          await dispatch(findTemplateQuestions(templateItem.template!.id.toString()));
          await dispatch(setNextDocumentCreateData(data));
          await dispatch(createDocumentFromTemplate([user, [userRole[0].code]]));
          await setNextDocumentCreateData({});
          await prepareStore();
        } catch (error) {
          console.log(error);
        }
      }
      try {

        // Asocia plantilla
        if (data.template && data.userId && data.assign === true) {
          const url = new URL(`${api.baseURL}formsubmitted`);
          const token = localStorage.getItem("token");
          const headers = new Headers();
          headers.append("Authorization", `Bearer ${token}`);
          headers.append("Content-Type", "application/json");

          const response = await fetch(url.toJSON(), {
            body: JSON.stringify({
              form: data.template,
              user: data.userId,
            }),
            method: "POST",
            headers: headers
          });
          if (!response.ok) {
            throw response.statusText;
          }
        }
      } catch (error) {
        return rejectWithValue(error);
      }

      return;
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);
